import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "shards-react";
import Swal from "sweetalert2";

import PageTitle from "../components/common/PageTitle";
import UserDetails from "../components/user-profile-lite/UserDetails";
import UserAccountDetails from "../components/user-profile-lite/UserAccountDetails";
import { Base_url } from "../requester";
import axios from "axios";
import LinearProgress from "@material-ui/core/LinearProgress";

const UserProfileLite = () => {
  const [user, setUser] = useState({});
  const [password, setPassword] = useState({
    password: "",
    newpassword: "",
    confirmpassword: "",
  });
  const [profile, setProfile] = useState("");
  const [file, setFile] = useState(null);

  const [profileimg, setProfileimg] = useState("");

  const [userloader, setuserLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isupdateloading, setUpdateloading] = useState(false);

  // useEffect(() => {
  //   const currentUser = async () => {
  //     setuserLoader(true);
  //     try {
  //       const res = await axios.get(Base_url + "/users/auth");
  //       if (res.data.status == "Success") {
  //         setUser(res.data.data);
  //         setProfileimg(res.data.data.profile);
  //         setuserLoader(false);
  //       }
  //     } catch (err) {
  //       setuserLoader(false);
  //     }
  //   };
  //   currentUser();
  // }, []);

  const onchange = (e) => {
    setUser((previous) => ({ ...previous, [e.target.name]: e.target.value }));
  };

  const onUpdateProfile = async () => {
    setUpdateloading(true);
    try {
      var formData = new FormData();
      formData.append("fullname", user.fullname);
      formData.append("address", user.address);
      formData.append("description", user.description);
      formData.append("profile", profile);
      const res = await axios.post(Base_url + "/users/updateprofile", formData);
      if (res.data.status == "Success") {
        await Swal.fire("Update Profile", res.data.message, "success");

        setUpdateloading(false);
      }
    } catch (err) {
      await Swal.fire("Update Profile", err.response.data.message, "warning");
      setUpdateloading(false);
    }
  };
  const handleChange = (event) => {
    setFile(URL.createObjectURL(event.target.files[0]));
    setProfile(event.target.files[0]);
  };

  const onUpdatePassword = async () => {
    setLoading(true);
    try {
      const res = await axios.post(Base_url + "/users/changepassword", {
        password: password.password,
        newpassword: password.newpassword,
        confirmpassword: password.confirmpassword,
      });
      if (res.data.status == "Success") {
        await Swal.fire("Update Password", res.data.message, "success");
        setPassword({
          password: "",
          newpassword: "",
          confirmpassword: "",
        });

        setLoading(false);
      }
    } catch (err) {
      await Swal.fire("Update Password", err.response.data.message, "warning");
      setLoading(false);
    }
  };

  const onchangePassword = (e) => {
    setPassword((previous) => ({
      ...previous,
      [e.target.name]: e.target.value,
    }));
  };
  return (
    <Container fluid className="main-content-container px-4">
      {userloader && <LinearProgress />}

      <Row noGutters className="page-header py-4">
        <PageTitle
          title="User Profile"
          subtitle="Overview"
          md="12"
          className="ml-sm-auto mr-sm-auto"
        />
      </Row>
      <Row>
        <Col lg="4">
          <UserDetails
            handleChange={handleChange}
            profileimg={profileimg}
            file={file}
            userDetails={user}
          />
        </Col>
        <Col lg="8">
          <UserAccountDetails
            onUpdateProfile={onUpdateProfile}
            password={password}
            onchangePassword={onchangePassword}
            onUpdatePassword={onUpdatePassword}
            onchange={onchange}
            userDetails={user}
            loading={loading}
            isupdateloading={isupdateloading}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default UserProfileLite;
